// Import model
import { ProjectNote } from '../models/ProjectNote';

// Import base class serializer
import { NoteSerializer } from './NoteSerializer';

// Import dependency types (models and enums used in properties)
import { Entity } from '../models/Entity';

// Import dependency serializers (for complex types)
import { EntitySerializer } from './EntitySerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for ProjectNote - handles JSON serialization and deserialization with type validation
 */
export class ProjectNoteSerializer {
  /**
   * Deserializes a JSON string into a ProjectNote instance
   */
  static deserialize(json: string): ProjectNote {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a ProjectNote instance
   */
  static fromObject(obj: any): ProjectNote {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to ProjectNote');
    }


    const instance: ProjectNote = {
      parentObjectType: obj['parentObjectType'] as string,
      parentObjectTypeName: obj['parentObjectType|Name'] as string | undefined,
      type_: obj['type'] as string | undefined,
      name: obj['name'] as string | undefined,
      description: obj['description'] as string | undefined,
      flowId: obj['flowId'] as string | undefined,
      flowIdName: obj['flowId|Name'] as string | undefined,
      objectStatusId: obj['objectStatusId'] as string | undefined,
      objectStatusIdName: obj['objectStatusId|Name'] as string | undefined,
      id: obj['_id'] as string | undefined,
      createdDate: obj['createdDate'] as string | undefined,
      lastModifiedDate: obj['lastModifiedDate'] as string | undefined,
      content: obj['content'] as string | undefined,
      contentType: obj['contentType'] as string | undefined,
      creatorId: obj['creatorId'] as string | undefined,
      creatorIdName: obj['creatorId|Name'] as string | undefined,
      entityId: obj['entityId'] as string | undefined,
      entityIdName: obj['entityId|Name'] as string | undefined,
      isActive: obj['isActive'] as boolean | undefined,
      relatedObjects: obj['relatedObjects'] as string | undefined,
      creator: obj['creator'] ? EntitySerializer.fromObject(obj['creator']) : undefined as any,
      _10E9Ba36: obj['_10e9ba36'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of ProjectNote instances
   */
  static deserializeArray(json: string): ProjectNote[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a ProjectNote instance to a JSON string
   */
  static serialize(instance: ProjectNote): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a ProjectNote instance to a plain object
   */
  static toObject(instance: ProjectNote): any {
    return {
      'parentObjectType': instance.parentObjectType,
      'parentObjectType|Name': instance.parentObjectTypeName,
      'type': instance.type_,
      'name': instance.name,
      'description': instance.description,
      'flowId': instance.flowId,
      'flowId|Name': instance.flowIdName,
      'objectStatusId': instance.objectStatusId,
      'objectStatusId|Name': instance.objectStatusIdName,
      '_id': instance.id,
      'createdDate': instance.createdDate,
      'lastModifiedDate': instance.lastModifiedDate,
      'content': instance.content,
      'contentType': instance.contentType,
      'creatorId': instance.creatorId,
      'creatorId|Name': instance.creatorIdName,
      'entityId': instance.entityId,
      'entityId|Name': instance.entityIdName,
      'isActive': instance.isActive,
      'relatedObjects': instance.relatedObjects,
      'creator': instance.creator ? EntitySerializer.toObject(instance.creator) : undefined,
      '_10e9ba36': instance._10E9Ba36,
    };
  }

  /**
   * Serializes an array of ProjectNote instances to a JSON string
   */
  static serializeArray(instances: ProjectNote[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
